import React from 'react';
import {PropTypes} from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import ActionLink from "../link/ActionLink";
import Button from "../button/Button";

const CardWidgetAltButton = (props) => (
    <React.Fragment>
      {
        !props.isLoading &&
            <Button text={props.text} onClick={props.onClick} isAlt isDisabled={props.isDisabled} params={props.params} />
      }
      {
        props.isLoading &&
        <Button text='' isDisabled={true}>
          <FontAwesomeIcon icon={faSpinner} />
        </Button>
      }
     <ActionLink/>
    </React.Fragment>
);

CardWidgetAltButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  params: PropTypes.object
};

export default CardWidgetAltButton;